
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/university/quality-control",
      function () {
        return require("private-next-pages/university/quality-control.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/university/quality-control"])
      });
    }
  